module.exports = __webpack_public_path__ + "img/post-play.d1c18faf.jpg";